var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('data-sync-panel',{attrs:{"title":"捷卫士数据同步","source":"捷卫士","use-jws-api":true}})}
var staticRenderFns = []

export { render, staticRenderFns }